import { BritishColumbiaObstetricalFileAlcohol } from "./Section9/BritishColumbiaObstetricalFileAlcohol";
import { BritishColumbiaObstetricalFileCannabis } from "./Section9/BritishColumbiaObstetricalFileCannabis";
import { BritishColumbiaObstetricalFileTobacco } from "./Section9/BritishColumbiaObstetricalFileTobacco";
import { BritishColumbiaObstetricalFileOtherSubstanceUse } from "./BritishColumbiaObstetricalFileOtherSubstanceUse";

class BritishColumbiaObstetricalFileSubstanceUse {
    public Alcohol: BritishColumbiaObstetricalFileAlcohol;
    public Tobacco: BritishColumbiaObstetricalFileTobacco;
    public Cannabis: BritishColumbiaObstetricalFileCannabis;
    public Other: BritishColumbiaObstetricalFileOtherSubstanceUse;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileSubstanceUse>) {
        Object.assign(this, fields);
        this.Alcohol = new BritishColumbiaObstetricalFileAlcohol(fields?.Alcohol);
        this.Tobacco = new BritishColumbiaObstetricalFileTobacco(fields?.Tobacco);
        this.Cannabis = new BritishColumbiaObstetricalFileCannabis(fields?.Cannabis);
        this.Other = new BritishColumbiaObstetricalFileOtherSubstanceUse(fields?.Other);
    }
}

export { BritishColumbiaObstetricalFileSubstanceUse };
